export function getSearchFilterTabItemSizingClassName(
  tabItemSize: string
): string {
  switch (tabItemSize) {
    case 'dynamic':
      return 'search-filters-tab-item-dynamic';
    case 'fixed':
      return 'search-filters-tab-item-fixed';
    case 'fill':
      return 'search-filters-tab-item-fill';
    default:
      return 'search-filters-tab-item-dynamic';
  }
}

export function getSearchFilterTabItemsContainerClassName(
  tabItemSize: string
): string {
  switch (tabItemSize) {
    case 'dynamic':
      return 'search-filters-tab-container-dynamic';
    case 'fixed':
      return 'search-filters-tab-container-fixed';
    case 'fill':
      return 'search-filters-tab-container-fill';
    default:
      return 'search-filters-tab-container-dynamic';
  }
}

export function getSearchFilterTabItemsAlignmentClassName(
  tabItemAlignment: string
): string {
  switch (tabItemAlignment) {
    case 'left':
      return 'search-filters-tab-items-left';
    case 'center':
      return 'search-filters-tab-items-center';
    case 'right':
      return 'search-filters-tab-items-right';
    default:
      return 'search-filters-tab-items-left';
  }
}

export function getSearchFilterTabItemInnerAlignmentClassName(
  tabItemInnerAlignment: string
): string {
  switch (tabItemInnerAlignment) {
    case 'left':
      return 'search-filters-tab-item-inner-left';
    case 'center':
      return 'search-filters-tab-item-inner-center';
    case 'right':
      return 'search-filters-tab-item-inner-right';
    default:
      return 'search-filters-tab-item-inner-center';
  }
}

export function getSearchFilterBorderStyleClassName(
  property: string,
  borderStyle: string
): string {
  switch (borderStyle) {
    case 'all':
      return `${property}-all`;
    case 'top':
      return `${property}-top`;
    case 'bottom':
      return `${property}-bottom`;
    default:
      return `${property}-bottom`;
  }
}
